export default {
    getList(state) {
        return state.orders;
    }
}
